var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HeartStraight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4419 16.5533L16.7726 10.2227C18.3281 8.66717 18.5576 6.10814 17.0855 4.47343C16.7168 4.06277 16.2683 3.73155 15.7673 3.49997C15.2664 3.26839 14.7235 3.1413 14.1718 3.12647C13.6201 3.11163 13.0712 3.20936 12.5585 3.41368C12.0458 3.618 11.5801 3.92464 11.1899 4.31488L10 5.50476L8.97267 4.47742C7.41717 2.92192 4.85814 2.69243 3.22343 4.16446C2.81277 4.53318 2.48155 4.9817 2.24997 5.48266C2.01839 5.98362 1.8913 6.52651 1.87647 7.0782C1.86163 7.6299 1.95936 8.17883 2.16368 8.69151C2.368 9.20419 2.67464 9.66987 3.06488 10.0601L9.55806 16.5533C9.67527 16.6705 9.83424 16.7364 10 16.7364C10.1658 16.7364 10.3247 16.6705 10.4419 16.5533V16.5533Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.a5c15f5e32bfb7b59c549e44a96b70c1.svg";
export { ForwardRef as ReactComponent };